<template>
  <v-data-table
    :headers="headers"
    :items="info"
    :loading="loading_state"
    :rows-per-page-items="rowsPerPageItems"
    :rows-per-page-text="labels.rows_per_page"
    :no-data-text="labels.no_data"
  >
    <template slot="items" slot-scope="props">
      <td>{{ props.item.Semester }}</td>
      <td>{{ props.item.CourseNo }}</td>
      <td>{{ props.item.CourseName }}</td>
      <td>{{ props.item.CreditPoint }}</td>
      <td>{{ props.item.RequireOption }}</td>
      <td>{{ props.item.AllYear }}</td>
      <td>{{ props.item.CourseTeacher }}</td>
      <td>
        <v-tooltip right>
          <template v-slot:activator="{ on }">
            <span v-on="on">
              {{ props.item.total_students }}({{ props.item.ChooseStudent }} /
              {{ props.item.ThreeStudent }})
            </span>
          </template>
          <span>{{ labels.total_registered_full }}</span>
        </v-tooltip>
      </td>
      <td style="word-break: break-all;">
        {{ props.item.Node }}
      </td>
      <td>{{ props.item.ClassRoomNo }}</td>
      <td v-html="props.item.Contents"></td>
      <td>
        <v-btn
          flat
          icon
          v-on:click="showDeital(props.item.CourseNo,props.item.Semester)"
          v-if="props.item.CourseNo != ''"
        >
          <v-icon>more_horiz</v-icon>
        </v-btn>
      </td>
    </template>
  </v-data-table>
</template>

<script>
import languages from "../../languages/Table.json";

export default {
  data: () => ({
    labels: {
      rows_per_page: "",
      no_data: "",
      total_registered_full: "",
      enable_class: "",
      select: "",
    },
    headers: [],
    rowsPerPageItems: [50, 100, { text: "All", value: -1 }],
  }),
  computed: {
    info() {
      return this.$store.state.info;
    },
    course_classes() {
      return this.$store.state.course_classes;
    },
    loading_state() {
      return this.$store.state.loading_state;
    },
    isLogin() {
      return this.$store.state.isLogin;
    },
    select_language() {
      return this.$store.state.select_language;
    },
  },
  watch: {
    select_language(value) {
      this.setLanguage(value);
    },
  },
  created() {
    this.setLanguage(this.$store.state.select_language);
  },
  methods: {
    showDeital: function(course_no,Semester) {
      this.$store.dispatch("queryDetial", {courseNo:course_no, Semester:Semester});
    },
    setLanguage: function(select_language) {
      this.labels.rows_per_page = languages.rows_per_page[select_language.lang];
      this.labels.no_data = languages.no_data[select_language.lang];
      this.labels.total_registered_full =
        languages.total_registered_full[select_language.lang];
      this.labels.enable_class = languages.enable_class[select_language.lang];
      this.labels.select = languages.select[select_language.lang];

      this.headers = [
        {
          text: languages.semester[select_language.lang],
          width: "7%",
          align: "center",
          sortable: false,
        },
        {
          text: languages.course_code[select_language.lang],
          width: "7%",
          align: "center",
          sortable: false,
        },
        {
          text: languages.course_title[select_language.lang],
          width: "10%",
          align: "center",
          sortable: false,
        },
        {
          text: languages.credits[select_language.lang],
          width: "3%",
          align: "center",
          sortable: false,
        },
        {
          text: languages.require_option[select_language.lang],
          width: "3%",
          align: "center",
          sortable: false,
        },
        {
          text: languages.full_half[select_language.lang],
          width: "3%",
          align: "center",
          sortable: false,
        },
        {
          text: languages.instructor[select_language.lang],
          width: "7%",
          align: "center",
          sortable: false,
        },
        {
          text: languages.total_registered[select_language.lang],
          width: "10%",
          align: "center",
          sortable: false,
        },
        {
          text: languages.day_time[select_language.lang],
          width: "13%",
          align: "center",
          sortable: false,
        },
        {
          text: languages.location[select_language.lang],
          width: "7%",
          align: "center",
          sortable: false,
        },
        {
          text: languages.notes[select_language.lang],
          width: "25%",
          align: "center",
          sortable: false,
        },
        {
          text: languages.outline[select_language.lang],
          width: "3%",
          align: "center",
          sortable: false,
        },
      ];

      this.rowsPerPageItems = [
        50,
        100,
        { text: languages.all[select_language.lang], value: -1 },
      ];
    },
  },
};
</script>
